import { RootState } from "../../reducers";
import { ApiSession, KeycloakUser } from "./types";

export const userSelector = (state: RootState): KeycloakUser | null =>
  state.auth.user;

export const apiSessionSelector = (state: RootState): ApiSession | null =>
  state.auth.apiSession;
